module.exports = __webpack_public_path__ + "media/white_logo/kirgizia-fb3c1932.png";